import React, { useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as Yup from "yup";
import { useFormik } from "formik";
import TextInput from "../common/textfield/TextInput";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../common/Button";
import { failed, success } from "../common/Toastify";
import { verifyAndSetPass, userLogin } from "../api/AuthService";
import Lock from '../../assets/images/Lock.png';
import { useQueryParams } from "../../hooks/useQueryParams";
import IntservTokenValidation from "../Login/intserv-token-validation";
import { validation, conditionalValidation } from "../../utils/constants";

function SetPassword() {
    const navigate = useNavigate();
    const { state } = useLocation()
    let queryParams = useQueryParams();
    const username = state?.username?.toLowerCase() || queryParams.get('email')?.toLowerCase()
    const [btnLoading, setBtnLoading] = useState(false)
    const [apiTokenValidationModalShow, setApiTokenValidationModalShow] = useState(false)
    const formik = useFormik({
        initialValues: {
            verificationCode: "",
            password: state?.password || "",
            newPassword: "",
            confirmPass: "",
        },
        validationSchema: Yup.object({
            verificationCode: Yup.number().typeError('you must specify a number').required('Please Enter your Verification Code'),
            newPassword: conditionalValidation(
                Yup.string()
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&~])[A-Za-z\d@$!%*#?&~]{8,}$/, 
                    "Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*#?&~)"
                ),
                {
                    label: "Password",
                    mandatory: true
                }),
            confirmPass: conditionalValidation(
                Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
                {
                    label: "Confirm Password",
                    mandatory: true
                })
        }),
        onSubmit: (values) => {
            values.verificationCode = values.verificationCode?.trim();
            values.password = values.password?.trim();
            values.confirmPass = values.confirmPass?.trim();
            values.newPassword = values.newPassword?.trim();
            setBtnLoading(true)
            verifyAndSetPass({ ...values, username }).then(({ data, response }) => {
                if(data?.status === false) {
                    failed(data?.message || data?.error)
                } else {
                    if (data?.status === true) {
                    success(data?.message);
                    // Check if user is API user by attempting login with new password
                    userLogin({ username: username, password: values.newPassword }).then((loginRes) => {
                        if (loginRes?.status === true && loginRes?.user?.["custom:group"] === "API") {
                            setApiTokenValidationModalShow(true);
                        } else {
                            navigate("/");
                        }
                    }).catch(() => {
                        navigate("/");
                    });
                    }else if(response?.status == 401){
                        failed(response?.data?.message);
                    }else{
                        failed(data?.error);
                    } 
                }
            }).catch(res => {
                failed(res?.response?.data?.message || res?.response?.data?.message || res?.message);
            }).finally(() => setBtnLoading(false));
        },
    });

    return (
        <>
            <form className="custom-form" onSubmit={formik.handleSubmit}>
                <Row>
                    <Col>
                        <TextInput style={{ background: "#F6F6F6", borderRadius: "10px", margin: "0", padding: "10px" }} keyField={"verificationCode"} label={"Verification Code"} formik={formik} placeholder={"999999"} />
                    </Col>
                </Row>
                {state?.password ? null : <Row>
                    <Col>
                        <TextInput type="password" icon={Lock} keyField={"password"} label={"Old Password"} formik={formik} placeholder={"Old Password"} />
                    </Col>
                </Row>}
                <Row>
                    <Col>
                        <TextInput type="password" icon={Lock} keyField={"newPassword"} label={"New Password"} formik={formik} placeholder={"New Password"} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextInput type="password" icon={Lock} keyField={"confirmPass"} label={"Confirm Password"} formik={formik} placeholder={"Confirm Password"} />
                    </Col>
                </Row>
                <div className="btn-wrap" style={{ display: 'flex' }}>
                    <Button type="submit" isLoading={btnLoading}>Submit</Button>
                </div>
            </form>
            {apiTokenValidationModalShow && <IntservTokenValidation modalShow={apiTokenValidationModalShow} handleClose={() => {
                setApiTokenValidationModalShow(false);
                navigate("/");
            }} />}
        </>
    );
}

export default SetPassword;